import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import Customer from './forms/Customer'
import Veterinary from './forms/Veterinary'

import { withStyles } from '@material-ui/core/styles'
import { Grid, Paper, Button, Snackbar } from '@material-ui/core'
import '../styles/auth-pages.css'
import logo from '../images/logo_light.png'
import customerButtonPressed from '../images/customer-button-pressed.png'
import customerButtonNotPressed from '../images/customer-button-not-pressed.png'
import vetButtonPressed from '../images/vet-button-pressed.png'
import vetButtonNotPressed from '../images/vet-button-not-pressed.png'

import { addUserAction } from '../actions/user'
import { resetErrors } from '../actions/global'

const styles = theme => ({
    root: {
        color: 'inherit',
        fontFamily: 'inherit',
        display: 'flex',
        flexWrap: 'wrap'
    }
});

class Register extends Component {
    constructor(props) {
        super(props);

        this.state = {
            grant_access: '',
            name: '',
            email: '',
            phone: '',
            document: '',
            estate: '',
            password: '',

            isVetRegister: false,
            errors: {},
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    onRegister = (event) => {
        event.preventDefault();

        let user = {
            grant_access: '',
            name: '',
            email: '',
            phone: '',
            cpf: '',
            crmv_region: '',
            crmv_number: '', 
            password: '',
        }

        if(this.state.isVetRegister){
                user.grant_access= 'professional';
                user.name= this.state.name;
                user.email= this.state.email;
                user.phone= this.state.phone;
                user.crmv_region= this.state.estate;
                user.crmv_number= this.state.document;
                user.password= this.state.password;
        }
        else{
                user.grant_access= 'customer';
                user.name= this.state.name;
                user.email= this.state.email;
                user.phone= this.state.phone;
                user.cpf= this.state.document;
                user.password= this.state.password;
        }

        this.props.addUserAction(user, this.props.history);
    }

    handleClickCustomer = () => {
        if(this.state.isVetRegister){
            this.setState(state => ({ isVetRegister: !state.isVetRegister }))
        }
    }

    handleClickVet = () => {
        if(!this.state.isVetRegister){
            this.setState(state => ({ isVetRegister: !state.isVetRegister }))
        }
    }

    handleSnackbarClose = () => {
        this.props.resetErrors();
    };

    render(){
        return(
            <div className="auth-background">
                <Grid container direction="row">
                    <Grid item xs      sm={8} md={8}/>
                    <Grid item xs={12} sm={4} md={3}> 
                        <Paper square className='auth-container'>
                            <Grid 
                                container
                                alignContent="center"
                                direction="column">
                                <Grid
                                    item
                                    container
                                    justify='center'
                                    alignContent='center'>
                                    <img className='logo' src={logo} alt="logo"/>
                                </Grid>
                                <Grid item>
                                    <Grid 
                                        className='auth-user-container'
                                        container
                                        alignContent='center'
                                        justify='space-around'>
                                        <Grid>
                                            <Button
                                                onClick={this.handleClickVet}>
                                                {this.state.isVetRegister ? <img src={vetButtonPressed} alt='Cadastro como veterinário'/> : <img src={vetButtonNotPressed} alt='Cadastro como consumidor'/>}
                                            </Button>
                                        </Grid>
                                        <Grid>
                                            <Button
                                                onClick={this.handleClickCustomer}>
                                                {this.state.isVetRegister ? <img src={customerButtonNotPressed} alt='Cadastro como veterinário'/> : <img src={customerButtonPressed} alt='Cadastro como consumidor'/>}
                                            </Button>
                                        </Grid>
                                        
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    {this.state.isVetRegister 
                                        ? <Veterinary
                                            userInput={this.handleChange.bind(this)}/> 
                                        : <Customer
                                            userInput={this.handleChange.bind(this)}/>}
                                </Grid>
                                <Grid>
                                    <Button
                                        variant="contained"
                                        className='contained-button register'
                                        onClick={this.onRegister}>
                                        REGISTRAR-SE
                                    </Button>
                                </Grid>
                                <Grid>
                                    <Snackbar 
                                        open={this.props.errors.addUser ? true : false}
                                        message={this.props.errors.addUser}
                                        onClose={this.handleSnackbarClose}/>
                                </Grid>                                      
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs      sm={false} md={1}/>                  
                </Grid>
                
            </div>
        )            
    }
}

function mapStateToProps(state) {
    return { 
        errors: state.user.errors,
    }   
}

function mapDispatchToProps(dispatch) {
    return {
        addUserAction: (user, history) => {
            dispatch(addUserAction(user, history))
        },
        resetErrors: () => {
            dispatch(resetErrors())
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Register)));